import axios from 'axios';
import { getEnv, JWT } from '../config';
import { EncryptData } from './rayEncrypt';

const CALL_DB_VERSION = 'v2';

// Data proxy base. Capture/test builds can point this at a local stub via
// REACT_APP_API_BASE; otherwise the environment (getEnv) selects prod/dev.
// Unset in normal prod/dev builds, so default behavior is unchanged.
const proxyBase = () =>
  process.env.REACT_APP_API_BASE ||
  (getEnv() === 'development'
    ? 'https://api-teams-info.raydevelop.com'
    : 'https://api-teams-info.rayteams.com');

export const DoDB = async (type, data, region = 'ap-northeast-2') => {
  const payload = {
    data: {
      type,
      region,
      params: data,
    },
  };
  if (CALL_DB_VERSION === 'v2') {
    return callDynamoV2(payload);
  }
  return callDynamoV1(payload);
};

async function callDynamoV1(payload) {
  try {
    const apiUrl = `${proxyBase()}/common/dynamo`;

    const ret = await axios.post(apiUrl, payload, JWT()).catch((error) => {
      // Handle network errors silently to prevent Sentry reporting
      if (error?.message?.includes('Failed to fetch') || error?.code === 'ERR_NETWORK') {
        console.warn('ERROR[callDynamoV1] Network error', error);
      } else {
        console.error('ERROR[callDynamoV1]', error);
      }
      return { data: [] };
    });
    return ret?.data || [];
  } catch (error) {
    // Handle any unexpected errors
    if (error?.message?.includes('Failed to fetch') || error?.code === 'ERR_NETWORK') {
      console.warn('ERROR[callDynamoV1] Network error', error);
    } else {
      console.error('ERROR[callDynamoV1]', error);
    }
    return [];
  }
}

async function callDynamoV2(originPayload) {
  try {
    const apiUrl = `${proxyBase()}/common/calldynamo`;
    // console.log('apiUrl', apiUrl);
    let payload;
    try {
      payload = await EncryptData(originPayload.data);
    } catch (encryptError) {
      console.error('ERROR[callDynamoV2] EncryptData failed', encryptError);
      return [];
    }
    if (window?.location?.origin.startsWith('http://localhost:')) {
      payload.debug = originPayload;
    }
    const ret = await axios.post(apiUrl, payload).catch((error) => {
      // Handle network errors silently to prevent Sentry reporting
      if (error?.message?.includes('Failed to fetch') || error?.code === 'ERR_NETWORK') {
        console.warn('ERROR[callDynamoV2] Network error', error);
      } else {
        console.error('ERROR[callDynamoV2]', error);
      }
      return { data: [] };
    });
    return ret?.data || [];
  } catch (error) {
    // Handle any unexpected errors
    if (error?.message?.includes('Failed to fetch') || error?.code === 'ERR_NETWORK') {
      console.warn('ERROR[callDynamoV2] Network error', error);
    } else {
      console.error('ERROR[callDynamoV2]', error);
    }
    return [];
  }
}
